export const generateURL = (path: string) => {
  return `https://firebasestorage.googleapis.com/v0/b/finesse-paint.appspot.com/o/${encodeURIComponent(
    path
  )}?alt=media`;
};
